import SaswataShath from '../images/Saswata.jpg';
import DiptanuGhosh from '../images/diptanuGhosh.jpg';
import TuhinChakraborty from '../images/tuhinChakraborty.jpg';
import SubhamShit from '../images/SubhamShit.jpg';
import ApurbaPal from '../images/ApurbaPal.jpg';



const TestimonialData = [
  {
    id:1,
    name: 'Saswata Shath',
    profile:'Physicist',
    institute: 'Burdwan University',
    about:'" Have been working with Soumyadip for quite a some time. I can undoubtedly say he is an extremely enthusiastic and helpful professional. He has a deep knowledge about project management and can also fix any problem regarding AI with ease. I am very much impressed by his communication skills as well as his flexibility. He is very sincere about his work and a punctual person too.But what makes him stand out is his ` never give up ` attitude and the willingness to help others. It is a great experience having worked with Soumyadip. I can surely recommend him to someone looking for a project manager or web developer. "',
    img: SaswataShath,
  },
  {
    id:2,
    name: 'Diptanu Ghosh',
    profile:'LAW Department',
    institute: 'Burdwan University',
    about:'" Soumyadip is a true professional who adheres to deadlines and delivers results promptly without compromising on quality. His passion for web development is evident in the seamless and user-friendly websites they create, tailored to meet the unique needs of each project.His ability to transform ideas into visually stunning and highly functional websites is truly commendable. I wholeheartedly recommend their services to anyone in need of a skilled and dedicated professional in the field. "',
    img: DiptanuGhosh,
  },
  {
    id:3,
    name: "Subham Shit",
    profile:'IT',
    institute: 'Techno India Group',
    about:'" I am delighted to share my experience working with Soumyadip on a recent ML Model Based web development project. Having collaborated with numerous professionals in the field, I can confidently say that Soumyadip stands out as an exceptional and talented web developer. Soumyadip possesses an impressive skill set that goes beyond technical proficiency. Communication was seamless throughout the entire process, and he was always open to feedback, making the collaboration a truly collaborative and enjoyable experience."',
    img: SubhamShit,
  },
  {
    id:4,
    name: 'Tuhin Chakraborty',
    profile:'MS CS Department',
    institute: 'Rani Rashmoni Green University',
    about:'"  Soumyadip consistently impressed me with his attention to detail and creative problem-solving skills. He approached every challenge with enthusiasm and a determination to find innovative solutions. What I appreciated most was his excellent communication skills—keeping me informed at every stage of the project process, ensuring that the final project aligned perfectly.Thank you, for your exceptional, outstanding work . I look forward to many more successful collaborations with you in the future. "',
    img: TuhinChakraborty,
  },
  {
    id:4,
    name: 'Apurba Pal',
    profile:'Chemist',
    institute: 'IIT Madras',
    about:'" I am delighted to provide a heartfelt testimonial for my friend, Soumyadip, whose technical knowledge and expertise have consistently impressed me and proven invaluable in various professional contexts.  He eagerly embraces new technologies, demonstrating a genuine enthusiasm for staying ahead of the curve. This commitment to ongoing self-improvement not only benefits him personally but also positively influences those fortunate enough to collaborate with him."',
    img: ApurbaPal,
  },

  
];

export default TestimonialData;